import './Ueberschriften.css';
import Table from 'react-bootstrap/Table';

const Ueberschriften = () => {
    return (
        <Table className="ueberschriftenTable text-center">
            <thead>
                <tr><th className="ueberschriftenCell">Spieler</th></tr>
                <tr><th className="ueberschriftenCell">1</th></tr>
                <tr><th className="ueberschriftenCell">2</th></tr>
                <tr><th className="ueberschriftenCell">3</th></tr>
                <tr><th className="ueberschriftenCell">4</th></tr>
                <tr><th className="ueberschriftenCell">5</th></tr>
                <tr><th className="ueberschriftenCell">6</th></tr>
                <tr><th className="ueberschriftenCell">Bonus</th></tr>
                <tr className="grayCell"><th className="ueberschriftenCell">Oben</th></tr>
                <tr><th className="ueberschriftenCell"></th></tr>
                <tr><th className="ueberschriftenCell">Dreierpasch</th></tr>
                <tr><th className="ueberschriftenCell">Viererpasch</th></tr>
                <tr><th className="ueberschriftenCell">Full House</th></tr>
                <tr><th className="ueberschriftenCell">Kl. Straße</th></tr>
                <tr><th className="ueberschriftenCell">Gr. Straße</th></tr>
                <tr><th className="ueberschriftenCell">Kniffel</th></tr>
                <tr><th className="ueberschriftenCell">Chance</th></tr>
                <tr><th className="ueberschriftenCell"></th></tr>
                <tr className="grayCell"><th className="ueberschriftenCell">Unten</th></tr>
                <tr className="grayCell"><th className="ueberschriftenCell">Gesamt</th></tr>
                <tr><th className="ueberschriftenCell text-danger">Platzierung</th></tr>
            </thead>
        </Table>
    )
}

export default Ueberschriften;